import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';
import { ServiceManagerService } from 'src/services/service-manager.service';
import { SocketService } from 'src/services/socket/socket.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  chatStartClicked: any = false;
  userName: any = '';
  @ViewChild('homeModal') modal: any;

  /**
   * Creates an instance of modal component.
   * @param commonService
   * @param serviceManager
   * @param socketService
   */
  constructor(
    public commonService: CommonService,
    private serviceManager: ServiceManagerService,
    private socketService: SocketService
  ) {}

  ngOnInit(): void {
    if (!this.commonService.appModalEvent.observed) {
      this.commonService.appModalEvent.subscribe((data: any) => {
        if (data == 'close-modal') {
          this.hide();
        } else if (data == 'chat-accept') {
          this.commonService.current.page = 'HOME';
          this.commonService.current.status = 'INITIAL';
          this.hide();
          this.commonService.checkChatExist().then((exist: any) => {
            if (exist)
              setTimeout(() => {
                this.commonService.showChat.next('show-chat');
              }, 1000);
          });
        } else if (data == 'chat-reject') {
          this.commonService.current.page = 'HOME';
          if (!this.isShown()) {
            this.show();
          }
          this.commonService.current.status = 'CHAT-REJECT';
        } else if (data == 'transfer-request') {
          this.commonService.current.status = data.toUpperCase();
          if (!this.isShown()) this.show();
        } else if (data == 'transfer-cancel') {
          this.commonService.current.page = 'HOME';
          this.commonService.current.status = 'REQUEST-ERROR';
          // this.userType = "Supporter"
          if (!this.isShown()) {
            this.show();
          }
        } else if (data == 'transferred') {
          this.commonService.current.page = 'TRANSFER-HOME';
          this.commonService.current.status = 'TRANSFERRED';
          this.commonService.checkChatExist(true);
          if (this.isShown()) {
            this.hide();
          }
          this.commonService.showChat.next('show-chat');
        } else if (data == 'request-error') {
          this.show();
          this.commonService.current.status = 'REQUEST-ERROR';
        }
      });
    }
  }

  /**
   * Shows modal component
   */
  show() {
    this.modal.show();
  }

  /**
   * Hides modal component
   */
  hide() {
    if (this.modal.isShown) this.modal.hide();
  }

  /**
   * Determines whether shown is
   * @returns
   */
  isShown() {
    return this.modal.isShown;
  }

  /**
   * Starts chat
   */
  startChat() {
    localStorage.removeItem('chatProcess');
    localStorage.removeItem('userId');
    this.chatStartClicked = true;
    if (!this.userName) {
      return;
    }
    this.commonService.peerDetails = this.commonService.selectedPeer;
    var body = {
      peer_id: this.commonService.selectedPeer.peerId,
      user_name: this.userName,
      is_transferred: false,
    };

    this.serviceManager.CallBackendServiceAPI('chat_request', body).subscribe({
      next: (data: any) => {
        var userId = data['response']['userId'];
        localStorage.setItem('userId', userId);
        this.commonService.current.status = 'CONNECTING';
        this.socketService.userDetails = {
          peerId: this.commonService.selectedPeer.peerId,
          peerName: this.commonService.selectedPeer.displayName,
          roomId: data['response']['roomId'],
          serviceUserName: this.userName,
          sessionId: data['response']['sessionId'],
          userId: userId,
        };
        this.socketService.setupSocketConnection();
        this.socketService.join(userId, 'SERVICE-USER');
        this.socketService.chatRequest();
        localStorage.setItem('currentProgress', 'chat-request');
        localStorage.removeItem('chatAccepts');
        // TODO: Remove this after testing
        // this.commonService.clearTimeout();
        // this.socketService.setAcceptTimeout();
      },
      error: () => {
        // e.g. the selected peer went offline (chat-request rejected) - the
        // error toast is shown by the HTTP interceptor; close this dialog so
        // the user isn't left staring at a request that will never proceed.
        this.chatStartClicked = false;
        this.hide();
      },
    });
  }

  /**
   * Transfers request response
   * @param status
   */
  transferRequestResponse(status: any) {
    if (status == 'accept') {
      this.socketService.transferChatResponse(true);
      this.commonService.current.status = 'TRANSFERRING';
    } else {
      this.modal?.hide();
      this.socketService.transferChatResponse(false);
    }
  }

  /**
   * Cancels request
   */
  cancelRequest() {
    this.socketService.chatRequestCancel();
  }
}
